import { render, staticRenderFns } from "./orderInfo.vue?vue&type=template&id=0652dcac&scoped=true"
import script from "./orderInfo.vue?vue&type=script&lang=js"
export * from "./orderInfo.vue?vue&type=script&lang=js"
import style0 from "./orderInfo.vue?vue&type=style&index=0&id=0652dcac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0652dcac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0652dcac')) {
      api.createRecord('0652dcac', component.options)
    } else {
      api.reload('0652dcac', component.options)
    }
    module.hot.accept("./orderInfo.vue?vue&type=template&id=0652dcac&scoped=true", function () {
      api.rerender('0652dcac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/homeManage/orderInfo.vue"
export default component.exports